import { CollectionAsset } from '../../../data/collection/types';
import { MediaType, tvpil } from '../../../data/compat/tvpil';
import { KalturaCollectionAsset } from '../../composed';
import {
  createAssetMetaOrTagGroupBy,
  createOnDemandResponseProfile,
  createPager,
  createPersonalListSearchFilter,
} from '../../factories';
import { processCollectionAsset } from '../../processing/collection';
import { fetchAssetList } from '../../services';
import { getRetrievedProperties, retrievedProperties } from '../collection';

import { fetchBookmarks } from './fetchBookmarks';

type FetchRecommendationsArgs = {
  groupBy?: string;
  kSql?: string;
  pageIndex: number;
  pageSize: number;
  partnerListTypeIn: string;
};

const vodMediaTypes = [MediaType.Episode, MediaType.Movie];

export async function fetchRecommendations({
  groupBy,
  kSql,
  pageIndex,
  pageSize,
  partnerListTypeIn,
}: FetchRecommendationsArgs) {
  const assetGroupBy = groupBy ? [createAssetMetaOrTagGroupBy({ value: groupBy })] : undefined;
  const retrievedPropertiesWithRatings = getRetrievedProperties({
    availableRatings: tvpil.availableRatingsNames,
    availableProviders: tvpil.availableProviders,
    retrievedProperties,
  });

  const { totalCount, objects } = await fetchAssetList<KalturaCollectionAsset>({
    filter: createPersonalListSearchFilter({
      partnerListTypeIn,
      groupBy: assetGroupBy,
      kSql,
    }),
    pager: createPager({
      pageIndex,
      pageSize,
    }),
    responseProfile: createOnDemandResponseProfile({
      retrievedProperties: retrievedPropertiesWithRatings,
    }),
  });

  const resObjects: CollectionAsset[] = [];
  const mediaAssetIds: number[] = [];
  const programIds: number[] = [];

  objects.forEach((it) => {
    if (tvpil.dms.mediaTypesValue[it.type] === MediaType.Program) {
      programIds.push(it.id);
    } else if (vodMediaTypes.includes(tvpil.dms.mediaTypesValue[it.type])) {
      mediaAssetIds.push(it.id);
    }
  });

  const [mediaBookmarks, epgBookmarks] = await Promise.all([
    mediaAssetIds.length
      ? fetchBookmarks({
          assetIds: mediaAssetIds,
          assetType: 'media',
        })
      : Promise.resolve([]),
    programIds.length
      ? fetchBookmarks({
          assetIds: programIds,
          assetType: 'epg',
        })
      : Promise.resolve([]),
  ]);

  const watchedMediaAssetIds = new Set(mediaBookmarks.map((it) => Number(it.id)));
  const watchedEpgAssetIds = new Set(epgBookmarks.map((it) => Number(it.id)));

  objects.forEach((it) => {
    if (!watchedMediaAssetIds.has(it.id) && !watchedEpgAssetIds.has(it.id)) {
      resObjects.push(processCollectionAsset(it));
    }
  });

  return {
    objects: resObjects,
    totalCount,
  };
}
